import React from 'react';
import { Users } from 'lucide-react';

const UserActivityChart = ({ data }) => {
  // Convert data object to array for rendering
  const chartData = Object.entries(data || {})?.map(([username, orders]) => ({
    username,
    orders: parseInt(orders) || 0
  }))?.sort((a, b) => b?.orders - a?.orders);

  const maxOrders = Math.max(...(chartData?.map(d => d?.orders) || [0]));

  return (
    <div className="bg-white rounded-lg shadow p-4 sm:p-6 overflow-hidden">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-medium text-gray-900">Attività Utenti</h3>
        <Users className="h-5 w-5 text-gray-400" />
      </div>
      {chartData?.length === 0 ? (
        <div className="text-center py-12 text-gray-500">
          <Users className="mx-auto h-12 w-12 text-gray-300 mb-4" />
          <p>Nessun dato di attività disponibile</p>
        </div>
      ) : (
        <div className="space-y-4">
          {chartData?.slice(0, 5)?.map((item) => (
            <div key={item?.username} className="flex flex-col gap-2 sm:flex-row sm:items-center">
              <div className="text-sm text-gray-600 break-words sm:w-24 sm:truncate">
                {item?.username}
              </div>
              <div className="w-full sm:mx-4 sm:flex-1">
                <div className="bg-gray-200 rounded-full h-4 relative">
                  <div
                    className="bg-purple-500 rounded-full h-4 transition-all duration-500"
                    style={{
                      width: `${maxOrders > 0 ? (item?.orders / maxOrders) * 100 : 0}%`
                    }}
                  />
                </div>
              </div>
              <div className="text-sm font-medium text-gray-900 sm:w-12 sm:text-right">
                {item?.orders}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UserActivityChart;
